<template>
    <!-- BaseAccountMenu.vue -->
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <v-menu>
                    <template v-slot:activator="{attrs, on}">
                        <v-btn depressed icon v-bind="attrs" v-on="on">
                            <base-avatar
                                v-if="emailAddress"
                                :email="emailAddress"
                                :name="name || emailAddress"
                                :size="32"
                            ></base-avatar>
                        </v-btn>
                    </template>
                    <v-list class="py-0">
                        <!-- @slot default -->
                        <slot></slot>
                    </v-list>
                </v-menu>
            </div>
        </template>
        Account
    </v-tooltip>
</template>

<script>
    // Components
    import BaseAvatar from './BaseAvatar'

    export default {
        name: 'BaseAccountMenu',
        props: {
            /**
             * The user's email address
             */
            emailAddress: {
                type: String,
                required: true
            },
            /**
             * The user's name
             */
            name: {
                type: String,
                default: ''
            }
        },
        components: {
            BaseAvatar
        }
    }
</script>
